export default function getSelectionStudents(activeSelection, {districts, schools, students}) {
  // Might have issues with this function when if any of the collections are blank. Watch for this issue.
  if (districts && schools && students) {
    if (districts[activeSelection]) {
      return {
        district: activeSelection,
        school: '',
        student: '',
      }
    } else if (schools[activeSelection]) {
      return {
        district: schools[activeSelection].district,
        school: activeSelection,
        student: '',
      }   
    } else if (students[activeSelection]) {
      return {
        district: students[activeSelection].schoolDistrict,
        school: students[activeSelection].school,
        student: activeSelection,
      }
    } else {
      return {
        district: '',
        school: '',
        student: '',
      }
    }
  } else {
    return {
      district: '',
      school: '',
      student: '',
    }
  }
}


// WEBPACK FOOTER //
// ./src/helpers/users/getSelectionStudents.js